import { getMethods } from './common';

// export default (type) => require(`./${type?.toLowerCase()}`).default;
export default (type) => require(`./${type?.toLowerCase()}.json`);

export const prepareSchemaProfile = (schema, methodParams) => {
  const {
    headerSchema,
    tableSettings: {
      initialSortColumn,
      initialSortDirection,
      pageSelectTitle,
      searchFields,
    },
    bodySchema,
    debugging,
  } = schema;

  const methods = getMethods(Object.assign(methodParams, { debugging }));

  if (debugging) {
    console.log('prepareSchemaProfile', {
      headerSchema,
      initialSortColumn,
      initialSortDirection,
      pageSelectTitle,
      searchFields,
      bodySchema,
      methods,
      debugging,
    });
  }

  return {
    headerSchema,
    initialSortColumn,
    initialSortDirection,
    pageSelectTitle,
    searchFields,
    bodySchema,
    methods,
    debugging,
  };
};
